<template>
  <div>
    <el-dialog
      title="申请发货"
      :visible.sync="dialogVisible"
      width="1000px"
      class="partShipment"
      @close="closeDialog"
    >
      <p>
        产品信息<span
          style="display: inline-block; color: red; margin-left: 50px"
        >
          <span>注：货运方式为供应商直发的产品预计在提交申请三天后发货</span>
          <span v-if="this.specialCloudDesc">;{{ this.specialCloudDesc }}</span>

        </span>
      </p>

      <el-table
        :data="tableData_dialog"
        border
        style="margin-top: 10px; margin-bottom: 10px"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column type="index" width="50" label="序号" fixed="left" align="left" />
        <el-table-column
          prop="exclusiveMaterialNumber"
          label="物品代码"
          align="left"
        />
        <el-table-column prop="productName" label="物品名称" align="left" />
        <el-table-column prop="productNum" label="数量" align="left" />
        <el-table-column
          prop="productPriceSigle"
          label="实际结算单价"
          align="right"
          header-align="left"
          width="160"
        />
        <el-table-column
          prop="settlementAmount"
          label="实际结算金额"
          align="right"
          header-align="left"
          width="160"
        />
        <el-table-column
          prop="expectedDeliveryDate"
          label="客户期望发货日"
          align="left"
          width="140"
        >
          <template v-slot="{ row }">
            {{ row.expectedDeliveryDate.substring(0, 10) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="agreedDate"
          label="约定交付日期"
          align="left"
          width="140"
        >
          <template v-slot="{ row }">
            {{ row.agreedDate.substring(0, 10) }}
          </template>
        </el-table-column>
      </el-table>

      <p style="font-size: 16px; font-weight: 800; margin: 10px 0">
        原信息
      </p>
      <p>
        <span>收货地址：</span>
        <span>{{ applyGoodsBaseInfo.province }}</span>
        <span>{{ applyGoodsBaseInfo.city }}</span>
        <span>{{ applyGoodsBaseInfo.county }}</span>
        <span>{{ applyGoodsBaseInfo.primaryReceiptAddress }}</span>
        <span class="ml-10">{{ applyGoodsBaseInfo.receiverName }}：</span>
        <span>{{ applyGoodsBaseInfo.receiverPhone }}</span>
      </p>
      <p>
        <span>运输方式：</span>
        <span>{{ applyGoodsBaseInfo.primaryModelOfShipping }}</span>
        <span style="margin-left: 20px">承运商：</span>
        <span>{{ applyGoodsBaseInfo.primaryCarrier }}</span>
      </p>
      <p style="font-size: 16px; font-weight: 800; margin: 10px 0">
        变更后信息
      </p>
      <p>
        <span>变更后收货地址：</span>
        <span>{{ address.province }}</span>
        <span>{{ address.city }}</span>
        <span>{{ address.county }}</span>
        <span>{{ address.receiptAddress }}</span>
        <span class="ml-10">{{ address.receiverName }}：</span>
        <span>{{ address.receiverPhone }}</span>
        <span>
          <el-button
            v-if="address.receiverName"
            type="text"
            style="padding: 0; margin-left: 15px"
            @click="updateAddress"
          >更改地址</el-button>
          <el-button
            v-if="!address.receiverName"
            type="text"
            style="padding: 0; margin-left: 15px"
            @click.stop="showAddress = true"
          >选择地址</el-button>
        </span>
      </p>
      <div v-loading="loadingChange">
        <p>
          <span>变更后运输方式：</span>
          <span class="rj-baseinfo__item">
            <el-radio-group v-model="shippingType" @change="shippingTypeChange">
              <el-radio :label="0">陆运</el-radio>
              <el-radio :label="1" :disabled="isHaveBattery">航空</el-radio>
            </el-radio-group>
          </span>
          <span>变更后承运商：</span>
          <span>
            <el-select
              v-model="carrierChangeValue"
              :disabled="isCarrierChangeValue"
              @change="carrierChange"
            >
              <el-option
                v-for="item in changeBussinessOptions"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </span>
        </p>
        <p>
          <span style="margin-right: 30px">运费差价：{{ freight }}元</span>
          <span v-if="this.freight != 0" class="rj-baseinfo__label">运费支付方式：</span>
          <span v-if="this.freight != 0" class="rj-baseinfo__item">
            <el-radio-group v-model="form.isRebate" @change="changisRebate">
              <el-radio :label="false">现金</el-radio>
              <el-radio :label="true">返利</el-radio>
            </el-radio-group>
            <template v-if="form.isRebate">
              使用金额: {{ form.rebateAmount }} 元
              <!-- eslint-disable-next-line vue/require-component-is -->
              <component
                v-bind="dialogNode"
                @chooesSuccess="chooseRebateSuccess"
              /> </template><br>
          </span>
        </p>
      </div>
      <p>
        <span>唛头单号：</span>
        <el-input
          v-model.trim="applyGoodsBaseInfo.partialInvoiceDetail.marksNum"
          style="width: 150px; margin-right: 10px"
          placeholder="请输入唛头单号"
        />
        <span>
          <span v-if="isRequiredEmail" class="required-tip">*</span>
          授权邮箱:
        </span>
        <el-input
          v-model.trim="
            applyGoodsBaseInfo.partialInvoiceDetail.authorizationEmail
          "
          style="width: 200px"
          placeholder="请输入授权邮箱"
        />
      </p>
      <p>
        <span style="display: inline-block; margin-top: 5px; margin-bottom: 5px">收货回执及到货验收要求：</span>
        <el-input
          v-model.trim="
            applyGoodsBaseInfo.partialInvoiceDetail
              .receiptArrivalAcceptanceRequirements
          "
          type="textarea"
          :rows="3"
          placeholder="请输入收货回执及到货验收要求"
          maxlength="200"
          show-word-limit
        />
      </p>
      <p>
        <span>回执附件</span>
        <el-upload
          action=""
          multiple
          :show-file-list="false"
          :http-request="uploadaction"
          style="display: inline-block; margin: 0 10px"
        >
          <el-button type="primary" :loading="isUploadLoading">
            上传附件
          </el-button>
        </el-upload>
      </p>

      <div v-for="(item, index) in fileList" :key="index">
        <span
          style="margin-right: 10px; color: #409eff"
          @click="fileClick(item)"
        >{{ item.fileName }}</span>
        <span style="color: #409eff; cursor: pointer" @click="deleteFile(index)"><i class="el-icon-error" /></span>
      </div>
      <p>
        <span style="display: inline-block; margin-top: 5px; margin-bottom: 5px">发货备注说明：</span>
        <el-input
          v-model.trim="applyGoodsBaseInfo.partialInvoiceDetail.deliverRemark"
          type="textarea"
          :rows="3"
          placeholder="请输入发货备注说明"
          maxlength="200"
          show-word-limit
        />
      </p>
      <p>
        <span style="display: inline-block; margin-top: 5px; margin-bottom: 5px">备注：</span>
        <el-input
          v-model.trim="applyGoodsBaseInfo.partialInvoiceDetail.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
          maxlength="200"
          show-word-limit
        />
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="closeDialog">关 闭</el-button>
        <el-button type="primary" :loading="isLoading" @click="submitFormData">提交</el-button>
      </span>
    </el-dialog>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
    <address-box
      :prop-open.sync="showAddress"
      @chooseAddress="changeAddress"
      @ChangeDatas="changeAddressData"
    />
  </div>
</template>
<script type="es6">
import { MathMulti, getNum } from '@/libs/util';
import addressBox from '@/views/address/index.vue';
import rebateUse from '../rabateUse.vue';
import rebateUsedList from '../rebateUsedList.vue';
import { mapState } from 'vuex';
import Big from 'big.js';
import AxiosApi from '@/API/fileAxios';

import {
  attachmentGetToken,
  getReceiptAddressInfoModel,
  getReceiptAddressByContractId,
  strategySaveApplyPartialShipment,
  getPartialShipmentFreight,
  getEditRebateUsedList,
  getRebateSummaryAgentInfo
} from '@/API';
import { mailboxVerification } from '@/API/international';
import { checkPartialShipmentCompliance } from '@/libs/partialShipmentCompliance';
export default {
  data () {
    return {
      dialogVisible: this.fpfhDialog,
      tableData_dialog: [],
      shippingType: 0,
      loading: false,
      address: {},
      loadingChange: false,
      isLoading: false,
      isHaveBattery: false,
      showAddress: false,
      carrierChangeValue: '默认物流',
      isCarrierChangeValue: false, // 承运商是否可点击
      changeBussinessOptions: ['默认物流', '顺丰'],
      specialCloudDesc: '',
      freight: '0', // 运费差价
      applyGoodsBaseInfo: {
        province: '',
        city: '',
        county: '',
        primaryReceiptAddress: '',
        primaryModelOfShipping: '',
        primaryCarrier: '',
        receiptAddress: '',
        modeOfShipping: '',
        carrier: '',
        freight: '',
        freightPayTypeStr: '',
        freightContractNum: '',
        freightProportion: '',
        marksNum: '',
        authorizationEmail: '',
        receiptArrivalAcceptanceRequirements: '',
        deliverRemark: '',
        remark: '',
        approvalOpinion: '',
        partialInvoiceDetail: {
          remark: ''
        }

      },
      contractInfo: {},
      form: {
        isRebate: false,
        rebateAmount: ''
      },
      sourceModifyAddress: true,
      // 文件参数
      uploadUrl: '',
      downFileUrl: '',
      fileserveDownUrl: '',
      token: '',
      fileList: [],
      dialogNode: {
        is: '',
        allow: 0,
        availableRebateAmount: 0,
        rebateUsedList: []
      },
      // 验证邮箱是否需要必填
      isRequiredEmail: false,
      // 文件上传laoding
      isUploadLoading: false
    };
  },
  props: {
    // 商务员工号
    regionBusinessCommissionerId: {
      type: String,
      default: ''
    }
  },
  components: {
    addressBox,
    // eslint-disable-next-line vue/no-unused-components
    rebateUse,
    // eslint-disable-next-line vue/no-unused-components
    rebateUsedList
  },
  computed: {
    ...mapState({
      salesType: (state) => state.enumeration.salesType,
      shipType: (state) => state.enumeration.shipType
    }),

    allowUserRate () {
      return MathMulti(this.form.orderSales, 0.3);
    }
  },

  watch: {
    freight (val) {
      this.dialogNode.allow = this.freight; // 最大返利金额   运费差价字段
    }
  },

  methods: {
    openDialog ({ tableList }, data) {
      this.contractInfo = data;
      // 原信息地址
      this.applyGoodsBaseInfo.receiptAddressId = data.receiptAddressId;
      this.applyGoodsBaseInfo.province = data.province;
      this.applyGoodsBaseInfo.city = data.city;
      this.applyGoodsBaseInfo.county = data.county;
      this.applyGoodsBaseInfo.primaryReceiptAddress = data.receiptAddress;
      this.applyGoodsBaseInfo.receiverName = data.receiverName;
      this.applyGoodsBaseInfo.receiverPhone = data.receiverPhone;

      this.applyGoodsBaseInfo.primaryModelOfShipping = data.modeOfShipping;
      this.applyGoodsBaseInfo.primaryCarrier = data.carrier;

      this.tableData_dialog = this.$cloneDeep(tableList);
      this.isRequiredEmail = false;
      this.address = {};
      this.dialogVisible = true;
      this.checkEmailIsRequired(this.tableData_dialog);
      this.partDialogOpen();
      this.getEditRebateUsedList();
      this.initToken();
    },

    closeDialog () {
      this.dialogVisible = false;
      this.shippingType = 0;
      this.freight = 0;
      this.carrierChangeValue = '默认物流';
      this.form.isRebate = false;
      this.fileList = [];
    },

    // 验证邮箱是否需要必填
    checkEmailIsRequired (array) {
      let params = array.map((item) => item.materialNumber);
      mailboxVerification(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.isRequiredEmail = data;
        }
      });
    },

    // 地址信息
    async partDialogOpen () {
      var res = await getReceiptAddressByContractId(this.$route.query.contractId);
      const json = res.data;
      if (json.status === '200') {
        let data = json.data;
        if (data === null) {
          data = [];
        }
        this.address = data;
      } else {
      }
    },

    // 返利查询
    getEditRebateUsedList () {
      getEditRebateUsedList({ contractNum: this.$route.query.contractNum })
        .then((res) => {
          let json = res.data;
          if (json.status === '200') {
            if (json.data.length) {
              this.dialogNode.rebateUsedList = json.data;
              this.dialogNode.is = 'rebate-used-list';
            } else {
              this.dialogNode.is = 'rebate-use';
            }
          }
        });
      getRebateSummaryAgentInfo({ contractNum: this.$route.query.contractNum })
        .then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.dialogNode.availableRebateAmount = json.data.availableAmount;
          }
        });
    },

    // 选择地址
    changeAddress (val) {
      this.address = val;
      this.showAddress = false;
      // 调用运费接口
      this.fecthFreightDifference();
    },

    // 校验是否含有电池和计算运费差价接口
    async fecthFreightDifference () {
      let list = this.tableData_dialog.map(item => {
        return {
          'id': item.id,
          'itemIndex': item.itemIndex || null,
          'lineNumber': null,
          'partialId': item.partialId || null,
          'orderNumber': item.orderNumber || null,
          'productName': item.productName || null,
          'materialNumber': item.materialNumberId || null,
          'productNum': item.productNum || null,
          'productPriceSigle': item.productPriceSigle || null,
          'settlementAmount': item.settlementAmount || null,
          'expectedDeliveryDate': item.expectedDeliveryDate || null,
          'freightProperty': item.freightProperty || null,
          'deliverState': item.deliverState || null,
          'agreedDate': item.agreedDate || null,
          'reason': item.reason || null,
          'propertyNum': item.propertyNum || null,
          'saleProductCode': item.productCode || null,
          'organization': item.organization || null,
          'warehouse': item.warehouse || null,
          'softFlag': item.softFlag ? 'N' : 'Y',
          'batteryFlag': item.batteryFlag || null,
          'erpProductPriceSigle': item.erpProductPriceSigle || null,
          'erpProductListPrice': item.erpProductListPrice || null,
          'borrowToSell': item.borrowToSell || null
        };
      });

      this.loadingChange = true;
      this.isHaveBattery = false;
      let params = {
        contractNum: this.$route.query.contractNum,
        shippingType: this.shippingType,
        receiptAddressId: this.address.id,
        partialInvoiceProductList: list,
        carrier: this.carrierChangeValue
      };
      const res = await getPartialShipmentFreight(params);
      this.loadingChange = false;
      const json = res.data;
      if (json.status === '200') {
        this.freight = json.data;
        // 默认物流 +陆运 = 0;
        if (this.carrierChangeValue === '默认物流' && this.shippingType === 0 && this.contractType !== 'SMB分销下单') {
          this.freight = 0;
        }
      } else if (json.status === '7100023') {
        // 包含电池状态码：7100023，不能选择航空
        this.isHaveBattery = true;

        this.getType();
      } else {
        this.getType();
      }
      // 如果是航空，禁用选择承运商
      if (this.shippingType === 1) {
        this.isCarrierChangeValue = true;
      } else {
        this.isCarrierChangeValue = false;
      }
    },

    // 判断当前状态 返回不同 shippingType
    getType () {
      this.shippingType = 0;
    },

    shippingTypeChange () {
      this.fecthFreightDifference();
    },

    carrierChange () {
      if (this.carrierChangeValue === '默认物流' && this.contractType !== 'SMB分销下单') {
        this.freight = 0;
      } else {
        this.fecthFreightDifference();
      }
    },

    // 文件上传
    uploadaction (upload) {
      this.isUploadLoading = true;
      const form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      const myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      AxiosApi.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        this.isUploadLoading = false;
        const json = res.data;
        if (json.status === '200') {
          this.fileList.push({
            fileName: json.data[0].FullName,
            fileToken: json.data[0].FID
          });
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        this.isUploadLoading = false;
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    deleteFile (tag) {
      this.fileList.splice(tag, 1);
    },
    // 下载文件地址
    fileClick (row) {
      this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      });
    },

    // 合计行的计算
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(getNum(cur.productNum)).plus(pre).toString()), 0);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(getNum(cur.settlementAmount)).plus(pre).toString()), 0);
        }
      });
      return sums;
    },

    // 返利切换
    changisRebate (val) {
      if (!val) {
        this.form.rebateAmount = 0;
        this.dialogNode.rebateUsedList = [];
      }
    },

    // 返利选中的回调
    chooseRebateSuccess (val) {
      this.rebateListVo = [];
      val.list.forEach((item) => {
        this.rebateListVo.push({
          rebateNum: item.rebateNumber,
          rebateTypeName: item.strRebateType,
          rebateAmount: item.useAmount
        });
      });
      this.form.rebateAmount = val.total;
      this.dialogNode.rebateUsedList = val.list;
    },

    // 更改地址
    updateAddress () {
      if (this.contractType === 'SMB分销下单' && this.sourceModifyAddress) {
        this.$message.error('抱歉，您已修改过发货地址，不允许再次修改地址');
        return false;
      }
      this.showAddress = true;
    },

    // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
    changeAddressData () {
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id)
          .then((res) => {
            let json = res.data;
            if (json.status === '200') {
              if (!json.data.isDelete) {
                this.address = json.data;
              } else {
                this.address = {};
              }
            }
          })
          .catch(() => { });
      }
    },

    // 提交
    async submitFormData () {
      const mailReg = /^([a-zA-Z0-9]+[_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[.|-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/;

      if (this.form.isRebate === true) {
        if (Number(this.form.rebateAmount) !== Number(this.freight)) {
          this.$message.error('分批发货运费支付方式选择返利，必须全部使用返利');
          return;
        }
      }

      if (this.isRequiredEmail) {
        if (!this.applyGoodsBaseInfo.partialInvoiceDetail.authorizationEmail) {
          this.$message.error('请输入邮箱');
          return;
        }
      }

      if (this.applyGoodsBaseInfo.partialInvoiceDetail.authorizationEmail && !mailReg.test(this.applyGoodsBaseInfo.partialInvoiceDetail.authorizationEmail)) {
        this.$message.error('请输入正确的邮箱格式');
        return;
      }

      this.isLoading = true;

      let list = this.tableData_dialog.map(item => {
        return {
          productName: item.productName,
          materialNumber: item.materialNumberId,
          productNum: item.productNum,
          productPriceSigle: item.productPriceSigle,
          settlementAmount: item.settlementAmount,
          expectedDeliveryDate: item.expectedDeliveryDate,
          agreedDate: item.agreedDate || null,
          saleProductCode: item.productCode || null,
          warehouse: item.warehouseLocation || null,
          softFlag: item.softFlag ? 'N' : 'Y',
          organization: item.organization,
          productId: item.id
        };
      });

      let params = {
        masterContractId: this.$route.query.contractId,
        masterContractNum: this.$route.query.contractNum,
        masterProjectName: this.$route.query.contractId,
        detail: {
          receiptAddressId: this.applyGoodsBaseInfo.receiptAddressId,
          partialAddressId: this.address.id,
          modeOfShipping: this.shippingType === 1 ? '航空' : '陆运',
          carrier: this.carrierChangeValue, // 承运商
          freight: this.freight, // 运费差价
          freightPayType: this.form.isRebate ? 1 : 0, // 支付方式
          freightUseRebate: null, // null
          amountSum: this.tableData_dialog.reduce((pre, cur) => getNum(Big(getNum(cur.settlementAmount)).plus(pre).toString()), 0), // 合计金额
          remark: this.applyGoodsBaseInfo.partialInvoiceDetail.remark, // 备注
          deliverRemark: this.applyGoodsBaseInfo.partialInvoiceDetail.deliverRemark,
          receiptArrivalAcceptanceRequirements: this.applyGoodsBaseInfo.partialInvoiceDetail.receiptArrivalAcceptanceRequirements,
          businessCode: this.regionBusinessCommissionerId,
          authorizationEmail: this.applyGoodsBaseInfo.partialInvoiceDetail.authorizationEmail, // 云桌面
          marksNum: this.applyGoodsBaseInfo.partialInvoiceDetail.marksNum // 唛头单号
        },
        strategyShipmentProducts: list,
        rebateListVo: this.rebateListVo, // 返利使用列表
        partialInvoiceFile: this.fileList// 文件
      };

      try {
        const canSubmit = await checkPartialShipmentCompliance({
          businessScene: 'DOMESTIC_PARTIAL_SHIPMENT_CHANNEL_SUBMIT',
          originalBizId: params.masterContractNum || params.masterContractId,
          contractInfo: this.contractInfo,
          address: this.address,
          products: params.strategyShipmentProducts,
          projectName: params.masterProjectName
        });
        if (!canSubmit) {
          this.isLoading = false;
          return;
        }
      } catch (error) {
        this.isLoading = false;
        this.$message.error(error.message || '出口合规检测失败');
        return;
      }

      strategySaveApplyPartialShipment(params)
        .then((res) => {
          let { status } = res.data;
          this.isLoading = false;
          if (status === '200') {
            this.closeDialog();
            this.$message.success('提交成功');
            this.$router.back();
          }
        }).catch(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
<style scope>
.partShipment p {
  margin: 5px 0;
}

.required-tip{
  position: relative;
  left: 2px;
  color: red;
}
.ml-10{
  margin-left: 10px;
}
</style>
